import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "./../../blent-component/Button";
import { Icon } from "./../../blent-component/Icon";
import { SideSheetModal } from "./../../blent-component/SideSheet";
import styles from "./styles.module.scss";

export const LanguageSwitcher = () => {
  const [visibleSelector, setVisibleSelector] = useState<boolean>(false);
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("selectedLanguage", lng);
    setVisibleSelector(false);
  };

  // const options = i18n.options.resources;

  const availableLanguages = Object.keys(i18n?.options?.resources ?? {});
  return (
    <div>
      <IconButton
        corners="rounded"
        noBorder
        size="m"
        icon={<Icon name="Language" size={24} color="#999" />}
        onClick={() => setVisibleSelector((prev) => !prev)}
        onKeyDown={function noRefCheck() {}}
        auto
        variant="tertiary"
      />
      <SideSheetModal
        // scrollableContent={false}
        open={visibleSelector}
        closeMe={() => setVisibleSelector(false)}
        position="top"
      >
        <div className={styles.selectorContainer}>
          {availableLanguages.map((x, i) => (
            <div key={i}>
              <IconButton
                icon={
                  <div className={styles.svgContainer}>
                    <img src={`/flag/${x}.svg`} alt={i18n.language} />
                  </div>
                }
                variant={x === i18n.language ? "secondary" : "tertiary"}
                corners="squared"
                onClick={() => changeLanguage(x)}
              ></IconButton>
            </div>
          ))}
        </div>
      </SideSheetModal>
    </div>
  );
};
